import React, { useContext } from "react";
import AppContext from "../../config/AppContext"; 
import InputBase from "@mui/material/InputBase";
import Paper from "@mui/material/Paper";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Box, Typography } from "@mui/material";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
import "./DescriptionInputFeedback.scss"
 
export default function DescriptionInputFeedback({
    value: propValue = "",
    onChange,
    onClick,
    label,
    maxLength = 100,
    ...props
  }) {
    const { mode } = useContext(AppContext); 
    const [value, setValue] = React.useState(propValue);
    const inputRef = React.useRef(null);
    const theme = useTheme();
    
    React.useEffect(() => {
      if (propValue !== value) {
        setValue(propValue);
      }
    }, [propValue]);
  
    const handleChange = (event) => {
      const inputValue = event.target.value;
      if (inputValue.length > maxLength) return;
      if (inputValue.trim().length === 0 && inputValue.length !== 0) return;
      setValue(inputValue);
      if (onChange) {
        onChange({ target: { value: inputValue } });
      }
    };
  
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        if (onClick) {
          onClick(value);
        }
      }
    };
  
    return (
      <div>
        <Paper
          component="form"
          variant="outlined"
          onClick={() => inputRef.current?.focus()}
          className="descrptionheight"
          sx={{
            display: "flex",
            alignItems: "flex-start",
            width: "100%",
            border: props.error ? "1px solid #FE5050" : mode === "dark" ? "1px solid #555" : "1px solid #D9D9D9",
            borderRadius: "0.625rem",
            background: mode === "dark" ? "transparent" : "transparent",
            color: mode === "dark" ? "#f8f8f8" : "#242424",
            overflowY: "auto",
            cursor: "text",
          }}
        >
          <InputBase
            inputRef={inputRef}
            value={value}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            multiline
            sx={{
              ml: 1,
              flex: 1,
              color: mode === "dark" ? "#f8f8f8 !important" : "#242424 !important",
              paddingTop: "10px",
              paddingLeft: "10px",
              "& textarea": {
                whiteSpace: "normal",
                textOverflow: "clip",
                display: "block",
                overflowY: "auto",
              },
              "&::placeholder": {
                color: mode === "dark" ? "#bbbbbb !important" : "#242424 !important",
              },
            }}
            placeholder={label}
            className="input-placeholders"
            inputProps={{ "gotham": label, maxLength }}
          />
        </Paper>
        {/* {props.error && (
          <Box display="flex" alignItems="center" pt={0.5}>
            <Box pr={0.5} mt={0.5}>
              <ErrorIcon />
            </Box>
            <Box display="flex" alignItems="center">
              <Typography id="tags-error-message" className="helper-text">
                {props.error}
              </Typography>
            </Box>
          </Box>
        )} */}
      </div>
    );
  }
  
 